/**
 * 解析 1688 商品链接中的商品 ID。
 *
 * 支持桌面版、移动版 offer 路径，以及 detail.m.1688.com 的 offerId 查询参数。
 * 非 1688 域名或非 HTTP(S) 链接会返回空字符串。
 *
 * @param {string} value 商品链接
 * @returns {string} 1688 商品 ID
 */
export function parse1688OfferId (value) {
  if (!value) return ''

  let url
  try {
    url = new URL(String(value).trim())
  } catch (error) {
    return ''
  }

  if (!['http:', 'https:'].includes(url.protocol)) return ''

  const hostname = url.hostname.toLowerCase().replace(/\.$/, '')
  if (hostname !== '1688.com' && !hostname.endsWith('.1688.com')) return ''

  const pathMatch = url.pathname.match(/\/offer\/(\d+)(?:\.html)?(?:\/|$)/i)
  if (pathMatch) return pathMatch[1]

  for (const [key, queryValue] of url.searchParams.entries()) {
    if (key.toLowerCase() === 'offerid' && /^\d+$/.test(queryValue)) {
      return queryValue
    }
  }

  return ''
}
